(function () {
  'use strict';

  // S650 定制母体（7 个隐藏 Shopify variant）与 Optionize 单套装 Trim Piece 控件
  // （决策 #66 c2a 起为 dropdown 原生 <select>，7 值 addOnPrice=0；兼容旧 button 形态）
  // 之间的选择同步、守卫与失败态（路线 Y · 决策 #61/#66）。
  //
  // 作用域白名单：仅新 S650 定制母体 handle（或显式 data-trim-piece-sync-target="s650-custom" /
  // TARGET_PRODUCT_IDS）会被本模块处理；其它 Optionize 多变体产品（如 4P 定制版）完全 no-op。
  // 监听：Optionize 容器事件委托（click/change/input 捕获）+ 局部 MutationObserver 兜底；
  // optionize-updated 仅作 preview/未来版本兼容（live 前台不派发）。
  // 切换：只写隐藏 variant-selects 的 select/radio 并派发冒泡 change，交回主题原生
  // VariantSelects.onVariantChange 完成价格/媒体/URL 更新，绝不跳 ?variant= 整页导航。
  // 守卫：配置缺失 / 映射缺失 / 同步失败 → 禁用加购 + role=status 提示；
  //       同步成功且价格 fetch 完成后才解除禁用。全局 try/catch 落到 setBlocked。
  // 冻结：无轮询、120ms 冷却、Z 熔断（3 批/3s 静默）、同值守卫幂等、settled mutation=0。
  // 1A-i（决策 #67）：每次 run() 按当前选中件位条件感知求和 ΣaddOnPrice（零售 cents），
  // 写 [data-ttc-price-source] 的 data-ttc-addon-retail-cents，补齐 4C 守卫 data 路；
  // 切件位即时清零，解析失败/选中态不明写 0（宁缺毋滥）。
  // 2A+6A（决策 #67，同批）：Trim Piece 锚定从 label 升级为 optionId（c2b 已实测 DOM
  // select#option-1788410589667 可用），label 仅兜底——Optionize 侧显示名改 Style 后零联动；
  // Vent 件位 variant 目标值同步改长名 'Driver Side Dash Vent Bezel'（与现货母体命名一致）。
  // F1（决策 #68）：G1 存活 marker（documentElement[data-ttc-addon-writer]，首次落盘后写、
  // 熔断/pagehide 摘除）+ D1 水合竞态修复（(a) !syncing 才置位、(c) run() 读回 re-arm ≤3）。
  // F3（决策 #68 批次）：isRelevantMutation class 匹配面补 image-swatch——取消选中的
  // React 晚提交不再漏补跑（Σaddon 粘滞修复）。

  // 主锚：套装 17769 Trim Piece dropdown 的 optionId（决策 #66 c2a 创建，稳定不变）。
  var TRIM_PIECE_OPTION_ID = 'option-1788410589667';
  var TRIM_PIECE_LABEL = 'Trim Piece';
  // label 兜底白名单：新显示名 'Style'（决策 #67 2A）+ 旧名 'Trim Piece'（回滚/旧缓存兼容）。
  var TRIM_PIECE_LABELS = ['Style', 'Trim Piece'];

  // 白名单：新 S650 定制母体 handle（设计 final-h2 §2.1）。
  var TARGET_PRODUCT_HANDLES = [
    'mustang-s650-2024-carbon-fiber-interior-trim-customization'
  ];
  // P1（2026-09-06 老板拍板）：4P 定制母体走 degraded 模式——无 Trim Piece/STYLE 锚组，
  // 只做「DOM 可见选中值 Σ加价 → 写 data-* + marker」；不做件位同步/禁购/隐藏。
  // 与 sync 模式 handle 表互斥；degraded 自守：只认精确 handle、绝不复用 explicit 短路。
  var DEGRADED_PRODUCT_HANDLES = [
    'mustang-2015-2023-carbon-fiber-interior-trim-kit-4-piece-set-customization'
  ];
  // 预留 product-id 白名单；一旦后台建好并回读 GID，可在此补强（不依赖单一数据源）。
  var TARGET_PRODUCT_IDS = [];
  var TARGET_ATTR = 'data-trim-piece-sync-target';
  var HIDDEN_ATTR = 'data-trim-piece-sync';

  // 左：Optionize Trim Piece 值归一化别名（scratch 17759 短名 + 生产可读名）。
  // 右：Shopify 变体 option1 精确值（决策 #61 / design-final-h2 §1 的 6 值命名）。
  var TRIM_TO_VARIANT = [
    { aliases: ['full', 'fullset', 'full7pieceset'],            variant: 'Full 7-Piece Set' },
    { aliases: ['5piece', '5pieceset', 'fivepieceset'],         variant: '5-Piece Set' },
    { aliases: ['vent', 'driverventbezel', 'driver side dash vent bezel', 'driversidedashventbezel'], variant: 'Driver Side Dash Vent Bezel' },
    { aliases: ['window', 'windowswitchbezelcovers'],           variant: 'Window Switch Bezel Covers' },
    { aliases: ['apillar', 'apillartrimpanels'],                variant: 'A-Pillar Trim Panels' },
    { aliases: ['passenger', 'passengerdashtrimpanel'],         variant: 'Passenger Dash Trim Panel' },
    { aliases: ['cluster', 'instrumentclusterhoodcover'],       variant: 'Instrument Cluster Hood Cover' }
  ];

  var COOLDOWN_MS = 120;
  var MUTATION_BREAKER_THRESHOLD = 3;
  var QUIET_MS = 3000;

  // G1（决策 #68，方案 A）：4C 守卫收窄——运行时存活 marker。模块在首次 syncAddonRetailCents
  // 落盘后才写 documentElement（语义=写入方真实存活且已产出，绝不由 Liquid 静态渲染）；
  // theme.liquid 守卫仅在每次调用时现读到 marker 才启用双路仲裁，否则前置早退、逐字节
  // 回退 8-28 单路（optFull 优先否则 datasetFull）。marker 挂 documentElement（不随
  // [data-ttc-price-source] 重渲染丢失，D3 瞬态不降级）；绝不加入守卫 attributeFilter。
  var WRITER_MARKER_ATTR = 'data-ttc-addon-writer';
  var WRITER_MARKER_VALUE = 'trim-piece-sync';
  // D1（决策 #68）：re-arm 计数上限（页生命周期内），防「React 受控组件永不固化」的理论
  // 乒乓；超限落 setBlocked('no-selection') = fail-closed，与未修时破态等价，不差。
  var REARM_MAX = 3;

  function normalizeLabel(value) {
    if (value === null || value === undefined) return '';
    return String(value).toLowerCase().replace(/\s+/g, ' ').trim();
  }

  // 映射比较键：大小写/空格/连字符不敏感（“5-Piece Set” == “5 Piece Set” == “5pieceset”）。
  function normalizeMatchKey(value) {
    return normalizeLabel(value).replace(/[-\s]/g, '');
  }

  function parseOptionSetJson(value) {
    var json;
    if (typeof value === 'string') {
      if (!value) return null;
      try { json = JSON.parse(value); } catch (e) { return null; }
    } else if (value && typeof value === 'object') {
      json = value;
    } else {
      return null;
    }
    if (!json || !Array.isArray(json.options)) return null;
    return json;
  }

  function isSingleSelectControl(option) {
    if (!option) return false;
    var type = String(option.type || '').toLowerCase();
    // dropdown 为原生 <select> 单选（决策 #66 c2a：套装 17769 Trim Piece button→dropdown 重建），
    // 天生 limit-1，无 maxSelectedValues 字段。
    if (type === 'dropdown') return true;
    if (type !== 'button') return false;
    var max = Number(option.maxSelectedValues);
    if (Number.isFinite(max) && max === 1) return true;
    var min = Number(option.min);
    var max2 = Number(option.max);
    if (Number.isFinite(min) && min === 1 && Number.isFinite(max2) && max2 === 1) return true;
    return false;
  }

  function findTrimPieceOption(setJson) {
    if (!setJson || !Array.isArray(setJson.options)) return null;
    var labelHit = null;
    for (var i = 0; i < setJson.options.length; i++) {
      var opt = setJson.options[i];
      if (!isSingleSelectControl(opt)) continue;
      // 主锚：optionId（决策 #67 2A）；命中即返回，label 改名零联动。
      if (opt && String(opt.id || '') === TRIM_PIECE_OPTION_ID) return opt;
      // 兜底：label/name（'Style'/'Trim Piece' 白名单，防 id 形态变动）。
      if (!labelHit) {
        var name = normalizeLabel(opt && (opt.label || opt.name));
        for (var k = 0; k < TRIM_PIECE_LABELS.length; k++) {
          if (name === normalizeLabel(TRIM_PIECE_LABELS[k])) { labelHit = opt; break; }
        }
      }
    }
    return labelHit;
  }

  function matchTrimRule(valueLabel) {
    var n = normalizeMatchKey(valueLabel);
    if (!n) return null;
    for (var i = 0; i < TRIM_TO_VARIANT.length; i++) {
      var rule = TRIM_TO_VARIANT[i];
      if (n === normalizeMatchKey(rule.variant)) return rule;
      for (var j = 0; j < rule.aliases.length; j++) {
        if (n === normalizeMatchKey(rule.aliases[j])) return rule;
      }
    }
    return null;
  }

  function buildTrimPieceVariantMap(setJson, variants) {
    var out = [];
    var trimOption = findTrimPieceOption(setJson);
    if (!trimOption || !Array.isArray(trimOption.values) || !Array.isArray(variants)) return out;
    for (var i = 0; i < trimOption.values.length; i++) {
      var v = trimOption.values[i] || {};
      var entry = { valueId: v.id, label: v.label || v.name || '' };
      var rule = matchTrimRule(entry.label);
      if (!rule) {
        entry.mapped = false;
        entry.ambiguous = false;
        entry.variantId = null;
      } else {
        var matches = [];
        for (var j = 0; j < variants.length; j++) {
          var variant = variants[j] || {};
          if (normalizeMatchKey(variant.option1) === normalizeMatchKey(rule.variant)) matches.push(variant);
        }
        if (matches.length === 1) {
          entry.mapped = true;
          entry.ambiguous = false;
          entry.variantId = String(matches[0].id);
          entry.available = matches[0].available !== false;
        } else {
          entry.mapped = false;
          entry.ambiguous = matches.length > 1;
          entry.variantId = null;
        }
      }
      out.push(entry);
    }
    return out;
  }

  function resolveVariantId(map, selected) {
    if (!Array.isArray(map) || selected === null || selected === undefined || selected === '') return null;
    var sid = String(selected);
    var i;
    for (i = 0; i < map.length; i++) {
      var e = map[i];
      if (e && e.valueId !== undefined && e.valueId !== null && String(e.valueId) === sid) {
        if (e.mapped && !e.ambiguous && e.variantId !== null) return String(e.variantId);
        return null;
      }
    }
    var n = normalizeMatchKey(selected);
    if (!n) return null;
    var found = null;
    for (i = 0; i < map.length; i++) {
      var entry = map[i];
      if (!entry || normalizeMatchKey(entry.label) !== n || !entry.mapped) continue;
      if (entry.ambiguous || entry.variantId === null) return null;
      if (found !== null) return null;
      found = entry;
    }
    return found ? String(found.variantId) : null;
  }

  function elText(el) {
    return el && typeof el.textContent === 'string' ? el.textContent : '';
  }

  function buttonValueId(el) {
    if (!el) return null;
    if (el.getAttribute) {
      var a = el.getAttribute('data-value-id') || el.getAttribute('data-option-value-id') || el.getAttribute('value');
      if (a !== null && a !== undefined && String(a) !== '') return String(a);
      // Optionize 2.8.8 button/swatch 实测：元素 id 即 value-id（option-value-* 前缀）。
      var eid = el.getAttribute('id');
      if (eid && String(eid).indexOf('option-value-') === 0) return String(eid);
    }
    if (el.dataset) {
      if (el.dataset.valueId) return String(el.dataset.valueId);
      if (el.dataset.optionValueId) return String(el.dataset.optionValueId);
    }
    return null;
  }

  function buttonValueLabel(el) {
    if (!el) return '';
    if (el.querySelector) {
      var labelEl = el.querySelector('.oz__option-value-label');
      var text = elText(labelEl).trim();
      if (text) return text;
    }
    var own = elText(el).trim();
    if (own) return own;
    if (el.value !== undefined) return String(el.value);
    return '';
  }

  // 取 select 当前选中的 <option>（c2b 实测：Optionize dropdown 的 <option value>=value-id，
  // option 文本=label，占位项 disabled value=""）。
  function selectedOptionOf(select) {
    if (!select) return null;
    var options = select.options || [];
    if (typeof select.selectedIndex === 'number' && options[select.selectedIndex]) {
      return options[select.selectedIndex];
    }
    for (var i = 0; i < options.length; i++) {
      if (options[i] && options[i].selected) return options[i];
    }
    var v = select.value;
    for (var j = 0; j < options.length; j++) {
      if (options[j] && String(options[j].value) === String(v)) return options[j];
    }
    return null;
  }

  // 从事件命中的控件读出「当前意图」选择：select 走 option 语义，button/input 走原路径。
  // 返回 { id, label }；占位/未选返回 { id: null, label: '' }；无法识别返回 null。
  function readControlSelection(control) {
    if (!control) return null;
    if (control.tagName === 'SELECT') {
      var v = control.value !== undefined ? String(control.value) : '';
      if (!v) return { id: null, label: '' };
      var opt = selectedOptionOf(control);
      var optId = opt && opt.getAttribute ? (opt.getAttribute('data-value-id') || null) : null;
      var optLabel = opt ? elText(opt).trim() : '';
      // value 即 value-id 时直接作 id；若实现变为 value=label，resolveVariantId 的 label 兜底仍命中。
      return { id: optId || v, label: optLabel || v };
    }
    return { id: buttonValueId(control), label: buttonValueLabel(control) };
  }

  function isTrimPieceGroupEl(group) {
    if (!group || !group.querySelector) return false;
    // 主锚：组内含 Trim Piece <select id=optionId>（决策 #67 2A，不再依赖 label 文本）。
    var select = group.querySelector('select');
    if (select && String(select.id || '') === TRIM_PIECE_OPTION_ID) return true;
    // 兜底：label 前缀/等值（button 形态无 select、或 Optionize 改 id 形态时的降级路径）。
    var labelEl = group.querySelector('.oz__option-label');
    var key = normalizeMatchKey(elText(labelEl));
    if (key.indexOf('trimpiece') === 0) return true;
    return key === 'style';
  }

  function findTrimPieceGroupEl(trimOption, doc) {
    if (!doc || !doc.querySelectorAll) return null;
    var groups = doc.querySelectorAll('.oz__option');
    if (!groups) return null;
    var names = {};
    for (var li = 0; li < TRIM_PIECE_LABELS.length; li++) names[normalizeMatchKey(TRIM_PIECE_LABELS[li])] = true;
    if (trimOption) {
      if (trimOption.label) names[normalizeMatchKey(trimOption.label)] = true;
      if (trimOption.name) names[normalizeMatchKey(trimOption.name)] = true;
    }
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (isTrimPieceGroupEl(group)) return group;
      var labelEl = group && group.querySelector ? group.querySelector('.oz__option-label') : null;
      var text = normalizeMatchKey(elText(labelEl));
      if (text && names[text]) return group;
    }
    for (var j = 0; j < groups.length; j++) {
      var fallback = groups[j];
      if (isTrimPieceGroupEl(fallback)) return fallback;
      var fallbackLabel = fallback && fallback.querySelector ? fallback.querySelector('.oz__option-label') : null;
      var fallbackText = normalizeMatchKey(elText(fallbackLabel));
      if (fallbackText.indexOf('trimpiece') !== -1) return fallback;
    }
    return null;
  }

  function readSelectedTrimPieceId(trimOption, doc) {
    var group = findTrimPieceGroupEl(trimOption, doc);
    if (!group || !group.querySelector) return null;
    // live Optionize 2.8.8 会把选中态类名放在 .oz__option-value 容器或其 button 上；
    // 先读任意 .oz__option-value--selected，再找其中的 button/input/select。
    var selectedContainer = group.querySelector('.oz__option-value--selected');
    if (selectedContainer) {
      var inner = null;
      if (selectedContainer.querySelector) {
        inner = selectedContainer.querySelector('.oz__option-element-button, input, select');
      }
      var el = inner || selectedContainer;
      if (el !== selectedContainer || selectedContainer.tagName !== 'DIV') {
        return { id: buttonValueId(el), label: buttonValueLabel(el) || (el.value || '') };
      }
    }
    var selectedButtons = group.querySelectorAll('.oz__option-element-button.oz__option-value--selected');
    var el = selectedButtons && selectedButtons[0];
    if (el) return { id: buttonValueId(el), label: buttonValueLabel(el) };
    var checked = group.querySelector('input:checked');
    if (checked) return { id: buttonValueId(checked), label: buttonValueLabel(checked) || (checked.value || '') };
    var select = group.querySelector('select');
    if (select) {
      var sel = readControlSelection(select);
      if (sel && (sel.id || sel.label)) return sel;
      return null; // 占位项（value=""）= 未选
    }
    return null;
  }

  // ---- 1A-i：data-ttc-addon-retail-cents 写入方（决策 #67，问题 1 修复）----
  // 4C 守卫（theme.liquid syncFullRetail）的 data 路 = data-price-cents×1.25 + Σaddon，
  // 但全主题从无写入方导致「只加加价不变变体」被守卫永久当瞬时旧值丢弃。本写入方补齐该路：
  // option-set JSON 的 addOnPrice 为美元字符串（'249.00'），零售口径 → cents 整数。
  // 求和条件感知（承重墙缓解 1）：只累计当前选中 Trim Piece 件位下条件规则
  // （optionId+valueId）生效组内的选中值；切件位旧组立即排除（清零）。
  // 宁缺毋滥（缓解 2）：解析失败/选中态不明 → null，调用方写 0 退回已知缺陷态，绝不写猜测值。

  function parseAddOnPriceCents(value) {
    if (value === null || value === undefined || value === '') return 0;
    var n = Number(value);
    if (!Number.isFinite(n) || n < 0) return null;
    return Math.round(n * 100);
  }

  function ruleMatchesTrim(rule, trimOption, trimSel) {
    if (!rule || !trimOption) return false;
    if (String(rule.optionId || '') !== String(trimOption.id || '')) return false;
    var v = rule.value !== undefined && rule.value !== null ? String(rule.value) : '';
    if (!v) return false;
    if (trimSel && trimSel.id !== null && trimSel.id !== undefined && trimSel.id !== '' && String(trimSel.id) === v) return true;
    if (trimSel && trimSel.label && normalizeMatchKey(trimSel.label) === normalizeMatchKey(v)) return true;
    return false;
  }

  // 条件感知判定：enableConditionalLogic=false → 恒生效；规则全部不锚 Trim Piece →
  // 无法判定（条件可能锚在别的选项上），保守不计。conditionalLogicType any/all 与
  // action show/hide 均按字面语义处理。
  function optionActiveForTrim(option, trimOption, trimSel) {
    if (!option) return false;
    if (trimOption && String(option.id) === String(trimOption.id)) return true; // Trim Piece 自身（addOn=0）
    if (!option.enableConditionalLogic) return true;
    var all = Array.isArray(option.conditionalLogicRules) ? option.conditionalLogicRules : [];
    var rules = [];
    var i;
    for (i = 0; i < all.length; i++) {
      if (all[i] && trimOption && String(all[i].optionId || '') === String(trimOption.id || '')) rules.push(all[i]);
    }
    if (!rules.length) return false;
    var type = String(option.conditionalLogicType || 'any').toLowerCase();
    var matched;
    if (type === 'all') {
      matched = true;
      for (i = 0; i < rules.length; i++) if (!ruleMatchesTrim(rules[i], trimOption, trimSel)) { matched = false; break; }
    } else {
      matched = false;
      for (i = 0; i < rules.length; i++) if (ruleMatchesTrim(rules[i], trimOption, trimSel)) { matched = true; break; }
    }
    var action = String(option.conditionalLogicAction || 'show').toLowerCase();
    if (action === 'hide') matched = !matched;
    return matched;
  }

  // Optionize 组 label 的纯净文本：真实 DOM 中 .oz__option-label 尾部嵌
  // .oz__option-price 价签 span（如 "5P - Carbon Fiber Style (+$0.00)"），需剔除。
  function optionGroupLabelText(labelEl) {
    if (!labelEl) return '';
    if (labelEl.childNodes) {
      var text = '';
      for (var i = 0; i < labelEl.childNodes.length; i++) {
        var n = labelEl.childNodes[i];
        if (n && n.nodeType === 3) text += n.textContent || '';
      }
      if (text && String(text).trim()) return text;
    }
    var full = elText(labelEl);
    var priceEl = labelEl.querySelector ? labelEl.querySelector('.oz__option-price') : null;
    if (priceEl) {
      var pt = elText(priceEl);
      if (pt) full = full.split(pt).join(' ');
    }
    return full;
  }

  // 付费组的 DOM 锚定：组内元素 id="option-value-*" ∈ option.values（2.8.8 实测形态）
  // 或 select#option-id 优先，其次控件 data-value-id，最后 .oz__option-label 归一等值兜底。
  function findOptionGroupEl(option, doc) {
    if (!option || !doc || !doc.querySelectorAll) return null;
    var groups = doc.querySelectorAll('.oz__option');
    if (!groups) return null;
    var valueIds = {};
    if (Array.isArray(option.values)) {
      for (var i = 0; i < option.values.length; i++) {
        var v = option.values[i];
        if (v && v.id !== undefined && v.id !== null) valueIds[String(v.id)] = true;
      }
    }
    var names = {};
    if (option.label) names[normalizeMatchKey(option.label)] = true;
    if (option.name) names[normalizeMatchKey(option.name)] = true;
    var labelHit = null;
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      if (!group || !group.querySelector) continue;
      var select = group.querySelector('select');
      if (select && option.id !== undefined && option.id !== null && select.id && String(select.id) === String(option.id)) return group;
      var controls = group.querySelectorAll
        ? group.querySelectorAll('.oz__option-element-button, .oz__option-element-swatch, input, select, [id^="option-value-"]')
        : [];
      for (var c = 0; controls && c < controls.length; c++) {
        var ctrl = controls[c];
        var cid = buttonValueId(ctrl);
        if (cid && valueIds[cid]) return group;
        if (ctrl && ctrl.tagName === 'SELECT') {
          var opts = ctrl.options || [];
          for (var o = 0; o < opts.length; o++) {
            var ov = opts[o] && opts[o].value !== undefined && opts[o].value !== null ? String(opts[o].value) : '';
            if (ov && valueIds[ov]) return group;
          }
        }
      }
      var labelEl = group.querySelector('.oz__option-label');
      var key = normalizeMatchKey(optionGroupLabelText(labelEl));
      if (key && names[key] && !labelHit) labelHit = group;
    }
    return labelHit;
  }

  // 读组内当前选中值集合：选中容器（.oz__option-value--selected）/checked input/select 三路。
  // 返回 [{id,label}]（空数组 = 组在但无选中）；组无效返回 null。
  function readSelectedOptionValues(group) {
    if (!group || !group.querySelectorAll) return null;
    var out = [];
    var seen = {};
    function push(id, label) {
      if (!id && !label) return;
      var key = String(id || '') + '|' + normalizeMatchKey(label);
      if (seen[key]) return;
      seen[key] = true;
      out.push({ id: id || null, label: label || '' });
    }
    var i;
    var selected = group.querySelectorAll('.oz__option-value--selected');
    for (i = 0; selected && i < selected.length; i++) {
      var el = selected[i];
      var inner = el.querySelector ? el.querySelector('.oz__option-element-button, .oz__option-element-swatch, input, select') : null;
      var ctrl = inner || el;
      push(buttonValueId(ctrl), buttonValueLabel(ctrl) || (ctrl.value || ''));
    }
    var checked = group.querySelectorAll('input:checked');
    for (i = 0; checked && i < checked.length; i++) {
      push(buttonValueId(checked[i]), buttonValueLabel(checked[i]) || (checked[i].value || ''));
    }
    var select = group.querySelector ? group.querySelector('select') : null;
    if (select) {
      var sel = readControlSelection(select);
      if (sel && (sel.id || sel.label)) push(sel.id, sel.label);
    }
    return out;
  }

  function valueEntryForSelection(option, sel) {
    if (!option || !Array.isArray(option.values) || !sel) return null;
    var i, v;
    if (sel.id !== null && sel.id !== undefined && sel.id !== '') {
      for (i = 0; i < option.values.length; i++) {
        v = option.values[i];
        if (v && v.id !== undefined && v.id !== null && String(v.id) === String(sel.id)) return v;
      }
    }
    var key = normalizeMatchKey(sel.label);
    if (key) {
      for (i = 0; i < option.values.length; i++) {
        v = option.values[i];
        if (v && normalizeMatchKey(v.label || v.name || '') === key) return v;
      }
    }
    return null;
  }

  // Σaddon（零售口径 cents）：只累计条件生效组内的选中值。
  // 返回 null = 解析失败/选中态不明（宁缺毋滥，调用方写 0）。
  function sumActiveAddOnCents(cfg, trimSel, doc) {
    if (!cfg || !cfg.setJson || !Array.isArray(cfg.setJson.options)) return null;
    if (!trimSel || (!trimSel.id && !trimSel.label)) return 0; // 未选件位 → 无生效加价组
    var total = 0;
    for (var i = 0; i < cfg.setJson.options.length; i++) {
      var option = cfg.setJson.options[i];
      if (!option || !Array.isArray(option.values) || !option.values.length) continue;
      var hasPaid = false;
      for (var j = 0; j < option.values.length; j++) {
        var probe = parseAddOnPriceCents(option.values[j] && option.values[j].addOnPrice);
        if (probe === null) return null; // addOnPrice 解析失败 → 宁缺毋滥
        if (probe > 0) hasPaid = true;
      }
      if (!hasPaid) continue; // 纯 0 组无需 DOM 判定（含 Trim Piece 自身）
      if (!optionActiveForTrim(option, cfg.trimOption, trimSel)) continue;
      var group = findOptionGroupEl(option, doc);
      if (!group) return null; // 生效付费组未渲染/锚定失败 → 选中态不明
      var selected = readSelectedOptionValues(group);
      if (selected === null) return null;
      for (var k = 0; k < selected.length; k++) {
        var entry = valueEntryForSelection(option, selected[k]);
        if (!entry) return null; // 选中值对不上 JSON → 不明
        var cents = parseAddOnPriceCents(entry.addOnPrice);
        if (cents === null) return null;
        total += cents;
      }
    }
    return total;
  }

  // P1 degraded：DOM 驱动求和（panel §3b 子路线 a）——只累计「当前已渲染且可见
  // （无 oz__ut-hidden）付费组内的选中值」，与 Optionize 自身总价口径天然一致；
  // 不扩展 optionActiveForTrim（4P 规则锚 Carbon Fiber Style 组，等于新写通用
  // 条件求值器，已否决）。返回 null = 选中态不明 → 调用方不写，保留上一稳定值。
  function degradedActiveAddOnCents(cfg, doc) {
    if (!cfg || !cfg.setJson || !Array.isArray(cfg.setJson.options) || !doc) return null;
    var total = 0;
    for (var i = 0; i < cfg.setJson.options.length; i++) {
      var option = cfg.setJson.options[i];
      if (!option || !Array.isArray(option.values) || !option.values.length) continue;
      var hasPaid = false;
      for (var j = 0; j < option.values.length; j++) {
        var probe = parseAddOnPriceCents(option.values[j] && option.values[j].addOnPrice);
        if (probe === null) return null;
        if (probe > 0) hasPaid = true;
      }
      if (!hasPaid) continue; // 纯 0 组无需 DOM 判定
      var group = findOptionGroupEl(option, doc);
      if (!group) return null; // 付费组未渲染/锚定失败 → 不明（等下次调度）
      if (group.classList && group.classList.contains('oz__ut-hidden')) continue; // 隐藏组不计
      var selected = readSelectedOptionValues(group);
      if (selected === null) return null;
      for (var k = 0; k < selected.length; k++) {
        var entry = valueEntryForSelection(option, selected[k]);
        if (!entry) return null; // 选中值对不上 JSON → 不明
        var cents = parseAddOnPriceCents(entry.addOnPrice);
        if (cents === null) return null;
        total += cents;
      }
    }
    return total;
  }

  function syncDegradedAddOnCents(cfg) {
    var total;
    try {
      total = degradedActiveAddOnCents(cfg, document);
    } catch (e) {
      total = null;
    }
    if (total === null) return; // 不明：不写（防止把可见价再打成基价口径）
    writeAddonRetailCents(total);
    markWriterAlive(); // G1 契约不变：成功落盘才重断言 marker
    ttcPriceRendererMarkDirty();
  }

  function runDegraded() {
    var cfg = readDegradedConfig();
    if (!cfg) return;
    syncDegradedAddOnCents(cfg);
  }

  window.TTCTrimPieceVariantSync = {
    version: '1.5.0',
    normalizeLabel: normalizeLabel,
    normalizeMatchKey: normalizeMatchKey,
    parseOptionSetJson: parseOptionSetJson,
    findTrimPieceOption: findTrimPieceOption,
    buildTrimPieceVariantMap: buildTrimPieceVariantMap,
    resolveVariantId: resolveVariantId,
    readSelectedTrimPieceId: readSelectedTrimPieceId,
    readControlSelection: readControlSelection,
    parseAddOnPriceCents: parseAddOnPriceCents,
    optionActiveForTrim: optionActiveForTrim,
    findOptionGroupEl: findOptionGroupEl,
    readSelectedOptionValues: readSelectedOptionValues,
    sumActiveAddOnCents: sumActiveAddOnCents,
    degradedActiveAddOnCents: degradedActiveAddOnCents
  };

  if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return;

  var state = 'idle'; // idle | loading | blocked | ready
  var syncing = false;
  var cooldown = false;
  var scheduledDuringCooldown = false;
  var breakerDisabled = false;
  var mutationCount = 0;
  var lastMutationAt = 0;
  var appObserver = null;
  var bootObservedApp = null;
  var reverseSyncDone = false;
  var pendingSelection = null;
  var reArmCount = 0; // D1(c)：外部重置 re-arm 计数（页生命周期内 ≤REARM_MAX）
  var NOOP = 'NOOP';

  function getApp() { return document.querySelector('optionize-app'); }
  function getHost() { return document.querySelector('variant-selects'); }
  function getSection(host) {
    if (!host || !host.closest) return null;
    return host.closest('.shopify-section') || host.closest('.popup-modal__content__data');
  }
  function getAddButton(host) {
    host = host || getHost();
    var form = null;
    if (host && host.dataset && host.dataset.section) {
      form = document.getElementById('product-form-' + host.dataset.section);
    }
    if (form && form.querySelector) {
      var b = form.querySelector('[name="add"]');
      if (b) return b;
    }
    return document.querySelector('[name="add"]');
  }
  function getVariantIdInput(host) {
    host = host || getHost();
    var form = host && host.dataset && host.dataset.section ? document.getElementById('product-form-' + host.dataset.section) : null;
    return form && form.querySelector ? form.querySelector('input[name="id"]') : null;
  }

  function setAttributeIfChanged(el, name, value) {
    if (!el || !el.setAttribute) return;
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function setStyleIfChanged(el, prop, value) {
    if (!el || !el.style) return;
    if (el.style[prop] !== value) el.style[prop] = value;
  }
  function setInert(el, inert) {
    if (!el) return;
    if (inert) {
      try { if (el.inert !== true) el.inert = true; } catch (e) {}
      setAttributeIfChanged(el, 'inert', '');
    } else {
      try { if (el.inert) el.inert = false; } catch (e) {}
      if (el.hasAttribute && el.hasAttribute('inert')) el.removeAttribute('inert');
    }
  }

  function setAddDisabled(disabled) {
    var b = getAddButton();
    if (!b) return;
    if (disabled) {
      if (!b.disabled) b.disabled = true;
      setAttributeIfChanged(b, 'aria-disabled', 'true');
    } else {
      if (b.disabled) b.disabled = false;
      if (b.hasAttribute && b.hasAttribute('aria-disabled')) b.removeAttribute('aria-disabled');
    }
  }

  function messageFor(reason) {
    var overrideKey = 'trimPieceVariantSync:' + reason;
    if (typeof window !== 'undefined' && window.themeStrings && window.themeStrings[overrideKey]) {
      return window.themeStrings[overrideKey];
    }
    switch (reason) {
      case 'optionize-missing':
      case 'optionize-not-loaded':
        return 'Loading trim piece options…';
      case 'no-selection':
        return 'Please select a trim piece.';
      case 'variant-unavailable':
        return 'This trim piece is sold out.';
      case 'sync-failed':
      case 'initial-variant-missing':
        return 'Selection could not be applied. Please refresh the page.';
      default:
        return 'This trim piece is not available right now.';
    }
  }

  function showMessage(text) {
    var el = document.querySelector('[data-trim-piece-sync-message]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-trim-piece-sync-message', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      var anchor = getHost() || document.querySelector('.product-form') || document.body;
      if (!anchor) return;
      if (anchor.parentNode && anchor.parentNode.insertBefore) {
        anchor.parentNode.insertBefore(el, anchor.nextSibling || anchor);
      } else if (anchor.appendChild) {
        anchor.appendChild(el);
      }
    }
    if (el.textContent !== text) el.textContent = text;
  }

  function setBlocked(reason) {
    state = 'blocked';
    setAddDisabled(true);
    showMessage(messageFor(reason));
  }

  function setReady() {
    state = 'ready';
    setAddDisabled(false);
    showMessage('');
  }

  function safeSetBlocked(reason) {
    try { setBlocked(reason); } catch (e) {}
  }

  function readProductScope() {
    var root = document.querySelector('section[data-product-handle], [data-product-handle]');
    var handle = root && root.getAttribute ? root.getAttribute('data-product-handle') : '';
    var explicit = !!document.querySelector('[' + TARGET_ATTR + '="s650-custom"]');
    var app = getApp();
    var pid = app && app.getAttribute ? app.getAttribute('product-id') : '';
    return { handle: normalizeLabel(handle), explicit: explicit, app: app, pid: pid };
  }

  function isTargetPage() {
    var scope = readProductScope();
    if (scope.explicit) return true;
    if (TARGET_PRODUCT_HANDLES.indexOf(scope.handle) !== -1) return true;
    if (scope.pid && TARGET_PRODUCT_IDS.indexOf(String(scope.pid)) !== -1) return true;
    return false;
  }

  // P1 自守①：degraded 只以精确 handle 命中，绝不复用 explicit 短路旁路；
  // sync 模式优先（S650 页永不进 degraded），同页两模式互斥。
  function isDegradedPage() {
    if (isTargetPage()) return false;
    var scope = readProductScope();
    return DEGRADED_PRODUCT_HANDLES.indexOf(scope.handle) !== -1;
  }

  function readVariants(host) {
    if (!host || !host.querySelector) return null;
    var script = host.querySelector('script[type="application/json"]');
    if (!script || typeof script.textContent !== 'string') return null;
    try {
      var data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : null;
    } catch (e) { return null; }
  }

  function readConfig() {
    var app = getApp();
    var pid = app && app.getAttribute ? app.getAttribute('product-id') : '';
    if (!pid) { setBlocked('optionize-missing'); return null; }
    var setEl = document.getElementById('optionize-option-set-' + pid);
    if (!setEl) { setBlocked('optionize-not-loaded'); return null; }
    var setJson = parseOptionSetJson(setEl.textContent);
    if (!setJson) { setBlocked('optionize-parse-error'); return null; }
    var trimOption = findTrimPieceOption(setJson);
    if (!trimOption) return NOOP; // 无 Trim Piece → 整体 no-op，绝不隐藏/禁购。
    var host = getHost();
    if (!host) { setBlocked('variant-selects-missing'); return null; }
    var variants = readVariants(host);
    if (!variants || !variants.length) { setBlocked('variant-json-missing'); return null; }
    var map = buildTrimPieceVariantMap(setJson, variants);
    if (!map || !map.length) { setBlocked('mapping-missing'); return null; }
    return { app: app, pid: pid, setJson: setJson, trimOption: trimOption, host: host, variants: variants, map: map };
  }

  // P1 degraded 配置读取：无 Trim Piece 锚组、无变体映射要求；只读套装 JSON 并自守。
  // 返回 null = 不可用/不存在/不明 → 调用方不写（宁缺毋滥，绝不写 0 猜测值）。
  function readDegradedConfig() {
    var app = getApp();
    var pid = app && app.getAttribute ? app.getAttribute('product-id') : '';
    if (!pid) return null;
    var setEl = document.getElementById('optionize-option-set-' + pid);
    if (!setEl) return null;
    var setJson = parseOptionSetJson(setEl.textContent);
    if (!setJson) return null;
    // 自守②：页面存在 Trim Piece/STYLE 锚组 → 拒绝 degraded（防与 sync 模式双写 marker）。
    if (findTrimPieceOption(setJson)) return null;
    // 自守③：无付费组则无写入意义（null 不写）。
    var hasPaid = false;
    if (Array.isArray(setJson.options)) {
      for (var i = 0; i < setJson.options.length && !hasPaid; i++) {
        var option = setJson.options[i];
        if (!option || !Array.isArray(option.values)) continue;
        for (var j = 0; j < option.values.length; j++) {
          var probe = parseAddOnPriceCents(option.values[j] && option.values[j].addOnPrice);
          if (probe === null) return null;
          if (probe > 0) { hasPaid = true; break; }
        }
      }
    }
    if (!hasPaid) return null;
    return { mode: 'degraded', app: app, pid: pid, setJson: setJson, host: getHost() };
  }

  // 1A-i 写入落点：[data-ttc-price-source]（.price__container--dealer 后代）的
  // data-ttc-addon-retail-cents 属性。theme.liquid 守卫的 MutationObserver
  // attributeFilter 含该属性（且 subtree），写入即触发 syncFullRetail 重算；
  // setAttributeIfChanged 同值不重写，避免自激 mutation。守卫 sumAddonCents 走
  // 后代求和路径读到此值（容器自身属性不占用）。
  // G1 marker 写入/清除（幂等）。marker 语义=「写入方存活且已产出」，只在首次
  // syncAddonRetailCents 落盘后写；readConfig 失败（setBlocked）时 run() 到不了这里，
  // marker 不会独存（expert-impl-2026-09-04 §1.2 红线）。
  function markWriterAlive() {
    if (typeof document === 'undefined' || !document.documentElement) return;
    setAttributeIfChanged(document.documentElement, WRITER_MARKER_ATTR, WRITER_MARKER_VALUE);
  }
  // G1 防粘滞：写入方失能（Z 熔断/页面卸载）时摘除 marker，守卫即刻回退 8-28 单路语义；
  // bfcache 恢复（pageshow persisted）会重跑 run() → syncAddonRetailCents 重新断言 marker。
  function clearWriterMarker() {
    if (typeof document === 'undefined' || !document.documentElement) return;
    var de = document.documentElement;
    if (de.getAttribute && de.getAttribute(WRITER_MARKER_ATTR) !== null && de.removeAttribute) {
      de.removeAttribute(WRITER_MARKER_ATTR);
    }
  }

  // 阶段1（决策 #72）：写入面从 dealer 容器扩展到全部 .price__container（含 D2C），
  // 使单价格渲染器在所有可见主价上有同一 addon 快路径；仍只写 [data-ttc-price-source]
  // 的 data-ttc-addon-retail-cents（唯一写方契约不变），同值守卫幂等。
  function writeAddonRetailCents(cents) {
    if (typeof document === 'undefined' || !document.querySelectorAll) return;
    var str = String(cents);
    var containers = document.querySelectorAll('.price__container, .price__container--dealer');
    for (var i = 0; containers && i < containers.length; i++) {
      var el = containers[i];
      var src = el && el.querySelector ? el.querySelector('[data-ttc-price-source]') : null;
      if (src) setAttributeIfChanged(src, 'data-ttc-addon-retail-cents', str);
    }
  }

  function ttcPriceRendererMarkDirty() {
    try {
      if (window && window.TTCPriceRenderer && typeof window.TTCPriceRenderer.markDirty === 'function') {
        window.TTCPriceRenderer.markDirty();
      }
    } catch (e) {}
  }

  // 1A-i 调度入口：每次 run() 按当前意图选择（pending 优先）即时重算并落盘；
  // 失败/不明 → 写 0（已知缺陷态：加价不显示但基准价正确），绝不写猜测值。
  function syncAddonRetailCents(cfg, trimSel) {
    var total;
    try {
      total = sumActiveAddOnCents(cfg, trimSel, document);
    } catch (e) {
      total = null;
    }
    writeAddonRetailCents(total === null ? 0 : total);
    markWriterAlive(); // G1：每次 run() 落盘顺带重断言 marker（expert-safety 防粘滞建议）
    ttcPriceRendererMarkDirty(); // 阶段1：只 markDirty，可见文本由单价格渲染器提交
  }

  function hideNode(el) {
    if (!el) return;
    setStyleIfChanged(el, 'display', 'none');
    setAttributeIfChanged(el, 'aria-hidden', 'true');
    setInert(el, true);
  }

  function normalizeThemeChrome(cfg) {
    var host = cfg.host;
    setStyleIfChanged(host, 'display', 'none');
    setAttributeIfChanged(host, 'aria-hidden', 'true');
    setAttributeIfChanged(host, HIDDEN_ATTR, 'hidden');
    setInert(host, true);
    var section = getSection(host);
    if (!section || !section.querySelectorAll) return;
    var selectOptions = section.querySelectorAll('select-option-js');
    for (var i = 0; selectOptions && i < selectOptions.length; i++) hideNode(selectOptions[i]);
    var buttons = section.querySelectorAll('.select-options-button');
    for (var j = 0; buttons && j < buttons.length; j++) hideNode(buttons[j]);
  }

  function rearmBreaker() {
    breakerDisabled = false;
    mutationCount = 0;
    lastMutationAt = 0;
  }

  function schedule() {
    // trailing-edge：冷却期内到达的调度不丢弃，冷却结束按最新状态补跑一次（c2b 修快速连切不收敛）。
    if (cooldown) { scheduledDuringCooldown = true; return; }
    cooldown = true;
    setTimeout(function () {
      cooldown = false;
      if (scheduledDuringCooldown) {
        scheduledDuringCooldown = false;
        schedule();
      }
    }, COOLDOWN_MS);
    if (typeof queueMicrotask === 'function') queueMicrotask(run);
    else setTimeout(run, 0);
  }

  function trimPieceControlFromEventTarget(t) {
    if (!t || !t.closest) return null;
    // 只接受 Trim Piece 组容器内的控件；其它 Optionize 组（款式/色板/textarea/email）绝不更新 pendingSelection。
    var group = t.closest('.oz__option');
    if (!group || !isTrimPieceGroupEl(group)) return null;
    return t.closest('.oz__option-element-button, input, select');
  }

  function onOptionizeInteraction(e) {
    var t = e && e.target;
    if (!t || !t.closest || !t.closest('optionize-app')) return;
    // 修复“落后一步”：点击/变更事件目标即用户意图值，先记为 pending。
    // Optionize 的 React state/DOM 提交可能晚于本事件，run() 优先使用 pending，
    // 不再抢读 DOM 旧选中态。
    var control = trimPieceControlFromEventTarget(t);
    // D1(a)（决策 #68）：syncing=true 窗口内的事件是 applyReverseSync/applyForwardSync 自己
    // 派发的程序化 change（dispatch 同步执行，capture 侦听在同一调用栈命中）——不得据它
    // 置位 pendingSelection/reverseSyncDone，否则初始反向对账被自己的写入骗成「已交棒」，
    // React 水合随后的空态重置再无人发现（水合竞态破态根因，expert-impl §2.2）。
    if (control && !syncing) {
      var sel = readControlSelection(control);
      // 占位/未选（id/label 均空）也要覆盖旧 pending，防止回退到上一次选择。
      if (sel) pendingSelection = sel;
      // 任何 Trim Piece 用户交互都代表“当前意图”，初始反向对账就此交棒，避免反向同步再覆盖用户选择。
      reverseSyncDone = true;
    }
    // 非 Trim Piece 组交互仍需 rearm + 重跑，让同步模块复核当前状态，但不改 pending。
    rearmBreaker();
    schedule();
  }

  function bindOptionizeEvents() {
    document.addEventListener('click', onOptionizeInteraction, true);
    document.addEventListener('change', onOptionizeInteraction, true);
    document.addEventListener('input', onOptionizeInteraction, true);
    document.addEventListener('optionize-updated', function () { rearmBreaker(); schedule(); });
    // 1A-i：变体切换触发 section 重渲染会替换 [data-ttc-price-source]（属性随之丢失）；
    // 常驻订阅 variantChange 补跑一次 run()，确保 Σaddon 属性在重渲染后即时重写。
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { rearmBreaker(); schedule(); });
    }
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('popstate', function () { reverseSyncDone = false; schedule(); });
      window.addEventListener('pageshow', function (e) { if (e && e.persisted) { reverseSyncDone = false; schedule(); } });
      // G1 防粘滞：卸载（含 bfcache 冻结）时摘除 marker；pageshow persisted 恢复后
      // 上面的 pageshow 分支已 schedule → run() → syncAddonRetailCents 重新断言。
      window.addEventListener('pagehide', function () { clearWriterMarker(); });
    }
  }

  function idIsOptionSet(node) {
    if (!node || !node.getAttribute) return false;
    var id = node.getAttribute('id') || '';
    return id.indexOf('optionize-option-set-') === 0;
  }

  function nodeIsRelevantElement(node) {
    if (!node || node.nodeType === 3) return false;
    if (node.matches) {
      try {
        if (node.matches('.oz__option, .oz__option-element-button, .oz__option-value-container') || idIsOptionSet(node)) return true;
      } catch (e) {}
    }
    if (node.querySelector) {
      try {
        if (node.querySelector('.oz__option, .oz__option-element-button, .oz__option-value-container') || node.querySelector('[id^="optionize-option-set-"]')) return true;
      } catch (e) {}
    }
    return false;
  }

  function nodeIsRelevantText(node, mutationTarget) {
    if (!node || node.nodeType !== 3) return nodeIsRelevantElement(node);
    var parent = node.parentElement || (mutationTarget && mutationTarget.parentElement) || mutationTarget;
    if (!parent || !parent.closest) return false;
    try {
      if (parent.closest('.oz__option, .oz__option-value-container')) return true;
      if (parent.closest('[id^="optionize-option-set-"]')) return true;
    } catch (e) {}
    return false;
  }

  function isRelevantMutation(mutations) {
    if (!mutations) return false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (!m) continue;
      if (m.type === 'attributes') {
        if (m.attributeName === 'class' && m.target && m.target.matches) {
          try {
            // F3（决策 #68 批次）：image-swatch 的选中/取消选中 class 变更落在 swatch 元素本体
            //（实测 .oz__option-element-image-swatch；readSelectedOptionValues 另引用
            // .oz__option-element-swatch）——不匹配则 React 晚一拍提交后无补跑，Σaddon 粘滞
            // 旧值（deselect 后 full 钉旧价，显示>计费）。mutation 在类名提交后送达，天然躲过竞态拍。
            if (m.target.matches('.oz__option-element-button, .oz__option-element-image-swatch, .oz__option-element-swatch, .oz__option-value, .oz__option-value-container')) return true;
          } catch (e) {}
        }
        continue;
      }
      if (m.type === 'characterData') {
        var parent = m.target && m.target.parentElement ? m.target.parentElement : null;
        if (parent && parent.closest) {
          try {
            if (parent.closest('.oz__option, .oz__option-value-container')) return true;
            if (parent.closest('[id^="optionize-option-set-"]')) return true;
          } catch (e) {}
        }
        continue;
      }
      if (m.type === 'childList') {
        var nodes = m.addedNodes && m.addedNodes.length ? m.addedNodes : m.removedNodes;
        if (!nodes) continue;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n) continue;
          if (n.nodeType === 3) {
            if (nodeIsRelevantText(n, m.target)) return true;
          } else if (nodeIsRelevantElement(n)) {
            return true;
          }
        }
      }
    }
    return false;
  }

  function onAppMutations(mutations) {
    if (!isRelevantMutation(mutations)) return;
    var now = Date.now();
    if (now - lastMutationAt > QUIET_MS) mutationCount = 0;
    lastMutationAt = now;
    if (breakerDisabled) return;
    mutationCount++;
    if (mutationCount >= MUTATION_BREAKER_THRESHOLD) {
      breakerDisabled = true;
      clearWriterMarker(); // G1 防粘滞：熔断=写入方失能，守卫回退 8-28 单路
      return;
    }
    schedule();
  }

  function ensureAppObserver(app) {
    app = app || getApp();
    if (!app) return;
    if (appObserver && appObserver._app === app) return;
    if (appObserver) appObserver.disconnect();
    appObserver = new MutationObserver(onAppMutations);
    appObserver._app = app;
    appObserver.observe(app, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function startBootObserver() {
    ensureAppObserver();
    new MutationObserver(function () {
      var app = getApp();
      if (!app) {
        if (bootObservedApp) bootObservedApp = null;
        return;
      }
      if (app !== bootObservedApp) {
        bootObservedApp = app;
        ensureAppObserver(app);
        schedule();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function findOptionByValue(select, value) {
    if (!select || !select.options) return null;
    for (var i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      var v = o.value !== undefined ? o.value : (o.textContent !== undefined ? o.textContent : o.text);
      if (String(v) === String(value)) return o;
    }
    return null;
  }

  function verifySync(cfg, targetVariantId) {
    var idInput = getVariantIdInput(cfg.host);
    var host = cfg.host;
    var hostOk = !host.currentVariant || String(host.currentVariant.id) === String(targetVariantId);
    var inputOk = idInput && String(idInput.value) === String(targetVariantId);
    if (hostOk && inputOk) setReady();
    else setBlocked('sync-failed');
  }

  function waitForPriceSync(cfg, targetVariantId) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS || !PUB_SUB_EVENTS.variantChange) {
      verifySync(cfg, targetVariantId);
      return;
    }
    var settled = false;
    var unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      if (settled) return;
      var variant = evt && evt.data && evt.data.variant;
      if (!variant || String(variant.id) !== String(targetVariantId)) return;
      settled = true;
      try { unsubscribe(); } catch (e) {}
      verifySync(cfg, targetVariantId);
    });
  }

  function applyForwardSync(cfg, targetVariantId) {
    var target = null;
    for (var i = 0; i < cfg.variants.length; i++) {
      if (String(cfg.variants[i].id) === String(targetVariantId)) { target = cfg.variants[i]; break; }
    }
    if (!target) { setBlocked('variant-not-found'); return; }
    if (target.available === false) { setBlocked('variant-unavailable'); return; }

    // 同步过程中先保持禁购，直到价格 fetch 完成（variant-change）或校验通过再 setReady。
    setAddDisabled(true);

    var host = cfg.host;
    var selects = host.querySelectorAll ? host.querySelectorAll('select') : [];
    var changed = false;
    var dispatcher = null;

    if (selects && selects.length) {
      for (var s = 0; s < selects.length; s++) {
        var opt = findOptionByValue(selects[s], target.option1);
        if (!opt) { setBlocked('variant-option-not-found'); return; }
        if (selects[s].value !== target.option1) {
          selects[s].value = target.option1;
          changed = true;
          dispatcher = dispatcher || selects[s];
        }
      }
    } else {
      var radios = host.querySelectorAll ? host.querySelectorAll('input[type="radio"]') : [];
      var matchedRadio = null;
      for (var r = 0; r < radios.length; r++) {
        if (radios[r].value === target.option1) {
          matchedRadio = radios[r];
          if (!radios[r].checked) {
            radios[r].checked = true;
            changed = true;
            dispatcher = dispatcher || radios[r];
          }
        }
      }
      if (!matchedRadio) { setBlocked('variant-option-not-found'); return; }
    }

    if (changed) {
      syncing = true;
      try {
        dispatcher.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        syncing = false;
        setBlocked('sync-failed');
        return;
      }
      waitForPriceSync(cfg, targetVariantId);
      if (typeof queueMicrotask === 'function') {
        queueMicrotask(function () { syncing = false; });
      } else {
        syncing = false;
      }
    } else {
      if (typeof queueMicrotask === 'function') queueMicrotask(function () { verifySync(cfg, targetVariantId); });
      else verifySync(cfg, targetVariantId);
    }
  }

  function readInitialVariantId(cfg) {
    var m = null;
    try {
      if (typeof window !== 'undefined' && window.location && window.location.search) {
        m = /[?&]variant=(\d+)/.exec(window.location.search);
      }
    } catch (e) {}
    if (m) return m[1];
    var idInput = getVariantIdInput(cfg.host);
    if (idInput && idInput.value) return String(idInput.value);
    if (cfg.variants[0]) return String(cfg.variants[0].id);
    return null;
  }

  function findMapEntryByVariant(map, variantId) {
    for (var i = 0; i < map.length; i++) {
      var entry = map[i];
      if (entry && entry.mapped && !entry.ambiguous && String(entry.variantId) === String(variantId)) return entry;
    }
    return null;
  }

  function findTrimButton(cfg, entry) {
    var group = findTrimPieceGroupEl(cfg.trimOption, document);
    if (!group || !group.querySelectorAll) return null;
    var buttons = group.querySelectorAll('.oz__option-element-button');
    if (entry.valueId !== undefined && entry.valueId !== null && entry.valueId !== '') {
      for (var i = 0; buttons && i < buttons.length; i++) {
        if (buttonValueId(buttons[i]) === String(entry.valueId)) return buttons[i];
      }
    }
    var targetLabel = normalizeMatchKey(entry.label);
    for (var j = 0; buttons && j < buttons.length; j++) {
      if (normalizeMatchKey(buttonValueLabel(buttons[j])) === targetLabel) return buttons[j];
    }
    return null;
  }

  function isSelectedTrimControl(btn) {
    if (!btn) return false;
    if (btn.classList && btn.classList.contains('oz__option-value--selected')) return true;
    try {
      if (btn.closest && btn.closest('.oz__option-value--selected')) return true;
    } catch (e) {}
    return false;
  }

  // 在 Trim Piece <select> 中定位 entry 对应 <option>：
  // 先按 value-id（data-value-id 或 option value），再按 label（文本或 value）归一匹配。
  function findTrimOptionEl(select, entry) {
    if (!select || !entry) return null;
    var options = select.options || [];
    var hasValueId = entry.valueId !== undefined && entry.valueId !== null && entry.valueId !== '';
    var i;
    if (hasValueId) {
      for (i = 0; i < options.length; i++) {
        var o = options[i];
        if (!o) continue;
        var oid = o.getAttribute ? (o.getAttribute('data-value-id') || '') : '';
        if (oid && String(oid) === String(entry.valueId)) return o;
        var oval = o.value !== undefined ? String(o.value) : '';
        if (oval && oval === String(entry.valueId)) return o;
      }
    }
    var targetLabel = normalizeMatchKey(entry.label);
    if (!targetLabel) return null;
    for (i = 0; i < options.length; i++) {
      var o2 = options[i];
      if (!o2) continue;
      if (normalizeMatchKey(elText(o2)) === targetLabel) return o2;
      if (o2.value !== undefined && normalizeMatchKey(o2.value) === targetLabel) return o2;
    }
    return null;
  }

  // 反向同步控件定位：dropdown 形态返回 select+option，button 形态返回 button。
  function findTrimSyncControl(cfg, entry) {
    var group = findTrimPieceGroupEl(cfg.trimOption, document);
    if (!group || !group.querySelector) return null;
    var select = group.querySelector('select');
    if (select) {
      var opt = findTrimOptionEl(select, entry);
      if (!opt) return null;
      return { kind: 'select', select: select, option: opt };
    }
    var btn = findTrimButton(cfg, entry);
    return btn ? { kind: 'button', button: btn } : null;
  }

  // Trim Piece 控件 DOM 存在性门控：select（dropdown）或 button/input 任一渲染出来才算就位。
  function findTrimControlEl(cfg) {
    var group = findTrimPieceGroupEl(cfg.trimOption, document);
    if (!group || !group.querySelector) return null;
    var select = group.querySelector('select');
    if (select) return { kind: 'select', group: group, el: select };
    var buttons = group.querySelectorAll('.oz__option-element-button');
    if (buttons && buttons.length) return { kind: 'button', group: group, el: buttons[0] };
    var input = group.querySelector('input');
    if (input) return { kind: 'input', group: group, el: input };
    return null;
  }

  function applyReverseSync(cfg) {
    var variantId = readInitialVariantId(cfg);
    if (!variantId) { setBlocked('initial-variant-missing'); return 'blocked'; }
    var variant = null;
    for (var i = 0; i < cfg.variants.length; i++) {
      if (String(cfg.variants[i].id) === String(variantId)) { variant = cfg.variants[i]; break; }
    }
    if (!variant) { setBlocked('initial-variant-missing'); return 'blocked'; }
    var entry = findMapEntryByVariant(cfg.map, variant.id);
    if (!entry) { setBlocked('reverse-mapping-missing'); return 'blocked'; }
    var control = findTrimSyncControl(cfg, entry);
    if (!control) { setBlocked('trim-button-missing'); return 'blocked'; }
    if (control.kind === 'select') {
      var desired = control.option.value !== undefined && control.option.value !== ''
        ? String(control.option.value)
        : String(entry.label);
      if (String(control.select.value) === desired) return 'aligned';
      syncing = true;
      try {
        control.select.value = desired;
        if (String(control.select.value) !== desired) {
          syncing = false;
          setBlocked('sync-failed');
          return 'blocked';
        }
        control.select.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        syncing = false;
        setBlocked('sync-failed');
        return 'blocked';
      }
      if (typeof queueMicrotask === 'function') queueMicrotask(function () { syncing = false; schedule(); });
      else { syncing = false; schedule(); }
      return 'clicked';
    }
    var btn = control.button;
    if (isSelectedTrimControl(btn)) return 'aligned';
    syncing = true;
    try {
      if (typeof btn.click === 'function') btn.click();
      else if (btn.dispatchEvent) btn.dispatchEvent(new Event('click', { bubbles: true }));
    } catch (e) {
      syncing = false;
      setBlocked('sync-failed');
      return 'blocked';
    }
    if (typeof queueMicrotask === 'function') queueMicrotask(function () { syncing = false; schedule(); });
    else { syncing = false; schedule(); }
    return 'clicked';
  }

  // D1(c)（决策 #68）：run() 门控读回校验——reverseSyncDone=true（已交棒/已对账）后，
  // 若当前变体仍能映射到 Trim entry 而 Trim 控件值与映射不符（典型=被重置回占位空值），
  // 判定为外部重置（React 水合 commit 晚于 applyReverseSync 的 microtask 读回窗口，
  // expert-impl §2.2 残余窗口）。单义判据：占位 <option value=""> 是 disabled，用户
  // 物理上无法选回空值；pendingSelection 在场时绝不判定（用户新意图优先，§4.1-2）。
  function detectExternalTrimReset(cfg) {
    if (pendingSelection) return false;
    var variantId = readInitialVariantId(cfg);
    if (!variantId) return false;
    var variant = null;
    for (var i = 0; i < cfg.variants.length; i++) {
      if (String(cfg.variants[i].id) === String(variantId)) { variant = cfg.variants[i]; break; }
    }
    if (!variant) return false;
    var entry = findMapEntryByVariant(cfg.map, variant.id);
    if (!entry) return false; // 当前变体无 Trim 映射 → 无从判定，不动
    var control = findTrimSyncControl(cfg, entry);
    if (!control || control.kind !== 'select') return false; // 空值单义判据仅 dropdown 形态成立
    var desired = control.option.value !== undefined && control.option.value !== ''
      ? String(control.option.value)
      : String(entry.label);
    return String(control.select.value) !== desired;
  }

  function run() {
    if (syncing) return;
    try {
      // P1：4P 定制页走 degraded 分子链（只写 data-* + marker，不做件位同步/禁购/隐藏）。
      if (isDegradedPage()) { runDegraded(); return; }
      var cfg = readConfig();
      if (cfg === NOOP) return;
      if (!cfg) return;
      // 隐藏门控：Trim Piece 控件（dropdown/button）在 DOM 就位后才隐藏原生 variant-selects；
      // Optionize 异步渲染窗口期保持现状，由 mutation/兜底调度重跑，不提前禁购。
      if (!findTrimControlEl(cfg)) return;
      normalizeThemeChrome(cfg);
      if (!reverseSyncDone) {
        var reverseResult = applyReverseSync(cfg);
        if (reverseResult === 'clicked' || reverseResult === 'blocked') return;
        if (reverseResult === 'aligned') reverseSyncDone = true;
      } else if (detectExternalTrimReset(cfg)) {
        // D1(c) re-arm：复用既有 applyReverseSync 路径（不另起第二套默认逻辑）；
        // 有界 ≤REARM_MAX/页生命周期，超限 fail-closed（与未修时破态等价，不差）。
        if (reArmCount >= REARM_MAX) { setBlocked('no-selection'); return; }
        reArmCount++;
        reverseSyncDone = false;
        var reArmResult = applyReverseSync(cfg);
        if (reArmResult === 'clicked' || reArmResult === 'blocked') return;
        if (reArmResult === 'aligned') reverseSyncDone = true;
      }
      var domSelected = readSelectedTrimPieceId(cfg.trimOption, document);
      var selected = domSelected;
      if (pendingSelection) {
        selected = pendingSelection;
        var domKey = domSelected ? normalizeMatchKey(domSelected.id || domSelected.label) : '';
        var pendingKey = normalizeMatchKey(pendingSelection.id || pendingSelection.label);
        if (domKey && domKey === pendingKey) pendingSelection = null;
      }
      // 1A-i（决策 #67）：按当前意图选择（pending 优先）即时重算 Σaddon 并写入
      // [data-ttc-price-source] 的 data-ttc-addon-retail-cents——切件位时旧条件组加价
      // 在此即刻清零，4C 守卫 data 路保持「变体基价 + 当前生效加价」稳定语义。
      syncAddonRetailCents(cfg, selected);
      if (!selected || (!selected.id && !selected.label)) { setBlocked('no-selection'); return; }
      var variantId = resolveVariantId(cfg.map, selected.id || selected.label);
      if (!variantId) { setBlocked('mapping-missing'); return; }
      applyForwardSync(cfg, variantId);
    } catch (e) {
      safeSetBlocked('sync-failed');
    }
  }

  function init() {
    if (!isTargetPage() && !isDegradedPage()) return;
    bindOptionizeEvents();
    startBootObserver();
    run();
    setTimeout(function () { try { run(); } catch (e) { safeSetBlocked('sync-failed'); } }, 300);
    setTimeout(function () { try { run(); } catch (e) { safeSetBlocked('sync-failed'); } }, 1500);
  }

  // 测试导出（expert-impl-2026-09-04 §2.4：D1 竞态在既有 vm harness 下不可达——
  // reverseSyncDone/run/applyReverseSync 全为闭包私有）。仅浏览器/doc 环境挂载；
  // 状态只读快照 + 交互入口 + 竞态编排用标志位直设，不改变任何运行时路径。
  if (typeof window !== 'undefined' && window.TTCTrimPieceVariantSync) {
    window.TTCTrimPieceVariantSync.__test = {
      run: run,
      onOptionizeInteraction: onOptionizeInteraction,
      applyReverseSync: applyReverseSync,
      clearWriterMarker: clearWriterMarker,
      markerAttr: WRITER_MARKER_ATTR,
      markerValue: WRITER_MARKER_VALUE,
      rearmMax: REARM_MAX,
      getState: function () {
        return {
          state: state, syncing: syncing, reverseSyncDone: reverseSyncDone,
          pendingSelection: pendingSelection, reArmCount: reArmCount,
          breakerDisabled: breakerDisabled
        };
      },
      setSyncing: function (v) { syncing = !!v; },
      setReverseSyncDone: function (v) { reverseSyncDone = !!v; }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
